import { merge } from 'lodash';
import { GPT_NETWORK_ID } from '../config';
import { commonAdUnits } from './common';
import { homepageAdUnits } from './homepage';
import { categoryAdUnits } from './category';
import { tagAdUnits } from './tag';
import { articleAdUnits } from './article';
import { webviewAdUnits } from './webview';
import { gameAdUnits } from './games';
const adUnits = merge({}, commonAdUnits, homepageAdUnits, categoryAdUnits, tagAdUnits, articleAdUnits, webviewAdUnits, gameAdUnits);

export const adConfig = {
  networkCode: GPT_NETWORK_ID,
  areas: adUnits,
};
